export function onPopupClickAwayWrapper(anchorEl, setAnchor) {
  function onPopupClickAway(e) {
    if (!setAnchor || !anchorEl) return;
    const { target } = e;
    const doesAnchorContainTarget = anchorEl && anchorEl.contains(target);
    const isAnchorTarget = anchorEl === target;
    if (!(doesAnchorContainTarget || isAnchorTarget)) {
      e.stopPropagation();
      setAnchor(null);
    }
  }
  return onPopupClickAway;
}
